import request from '@/utils/request'
// 清运车辆列表
export function carLists(query) {
    return request({
        url: 'manager/car/carLists',
        method: 'post',
        params: query
    })
}